'use client'

import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

import { AIMasterWidget } from '@/components/ai/AIMasterWidget'

export function AIMasterWidgetGate() {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) return null

  return createPortal(<AIMasterWidget />, document.body)
}